export const breakpoints = {
  small: 0,
  medium: '375px',
  large: '768px',
  xLarge: '1200px'
}
